import React from "react";
import { dateFormator } from "../../../../../../utils";
import { Divider } from "../../../../../../components";

const TimesheetHeader = ({
  data = {},
  color = "primary",
  colorDepth = 500,
  type = "main", // main, sub
}) => {
  return data?.client?.name ? (
    type === "main" ? (
      <div className={`header-main px-5  py-5 flex flex-col gap-1`}>
        {/* <div>
          <h5 className={`uppercase text-2xl font-semibold`}>Timesheet</h5>
        </div> */}
        {/* <div>
          {data?.employee?.name} :{" "}
          {dateFormator(data.timesheetPeriod.from, "short")} -{" "}
          {dateFormator(data.timesheetPeriod.to, "short")}
        </div> */}
        <div className="flex justify-between items-center gap-7  text-xs">
          <div className="flex-1">
            <div className="w-56 h-fit">
              <img
                src={data?.company?.companyLogo}
                alt={data?.company?.name}
                className="w-56"
              />
            </div>
          </div>
          <Divider
            textAlign="right"
            className="uppercase text-2xl font-semibold leading-none"
          >
            Timesheet
          </Divider>
        </div>
      </div>
    ) : (
      <div
        className={`header-main bg-${color}-50  flex justify-between items-end px-5  py-2 text-xs mb-5`}
      >
        {/* <div className="font-semibold">{data?.employee?.name}</div>
        <div className="flex items-center gap-3">
          <span>
            Timesheet : {dateFormator(data.timesheetPeriod.from, "short")} -{" "}
            {dateFormator(data.timesheetPeriod.to, "short")}
          </span>
        </div> */}
      </div>
    )
  ) : type === "main" ? (
    <div className="header-main bg-gray-50 text-center text-gray-300 py-2 px-5">
      <h5
        className={`uppercase text-2xl font-semibold text-${color}-${colorDepth}`}
      >
        Timesheet
      </h5>
    </div>
  ) : (
    <div className="header-main bg-gray-50  text-gray-300 py-2 px-5 text-sm text-start">
      <div className="flex items-center gap-3">
        <span>{dateFormator(new Date(), "day-shortMonth-year-time-utc")}</span>
      </div>
    </div>
  );
};

export default TimesheetHeader;
